// extracted by mini-css-extract-plugin
export default {"products":"HB-z","card":"IB-z","oosMessaging":"JB-z"};